import { useIntl } from 'react-intl';
import { ChevronLeft } from 'lucide-react';

interface BookingDetailHeaderProps {
  onBack: () => void;
}

/**
 * Desktop back affordance ("< Your activity"). Rendered by the page ONLY on desktop hosts (web /
 * tenant-portal, via host info) — on mobile the native shell header (history mode) provides back
 * instead. Both paths go back through browser history, so the feed's preserved tabs are restored.
 */
export const BookingDetailHeader = ({ onBack }: BookingDetailHeaderProps): JSX.Element => {
  const intl = useIntl();

  return (
    <div className="px-5 pb-4">
      <button
        type="button"
        onClick={onBack}
        className="-ml-1 flex cursor-pointer items-center gap-0.5 rounded text-[15px] font-semibold text-foreground outline-none focus-visible:ring-2 focus-visible:ring-system-blue focus-visible:ring-offset-1"
        data-testid="booking-detail-back"
      >
        <ChevronLeft size={20} strokeWidth={2} aria-hidden />
        {intl.formatMessage({ id: 'booking.detail.back' })}
      </button>
    </div>
  );
};
